// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"64f36b37","389":"d54ab993","453":"c3dda7cd","455":"bb5a157a","977":"120be5bd"}[chunkId] + ".chunk.js";
};